import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Image } from 'cloudinary-react';
import SponsorIcon from '@material-ui/icons/Group';
import { connect } from 'react-redux';
import Link from '@material-ui/core/Link';
import css from './SponsorsTicker.module.scss';
import toJS from '../../../lib/hocs/toJS';
import organizationDuck from '../../../redux/modules/organizationDuck';
import railsContextDuck from '../../../redux/modules/railsContextDuck';

const settings = (sponsorLength) => ({
  dots: false,
  arrows: false,
  autoplay: true,
  infinite: true,
  autoplaySpeed: 2000,
  pauseOnHover: false,
  slidesToShow: Math.min(sponsorLength, 5),
  slidesToScroll: 1,
  variableWidth: false,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: Math.min(sponsorLength, 4),
      },
    },
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: Math.min(sponsorLength, 3),
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: Math.min(sponsorLength, 2),
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

const styles = (theme) => {
  // const { contrastText, main } = theme.palette.primary;
  // const color = contrastText === 'rgba(0, 0, 0, 0.87)' ? contrastText : main;
  return {
    title: {
      // color: 'black',
      textDecoration: 'none',
      // textDecorationColor: 'black !important',
      textTransform: 'uppercase',
      display: 'inline-block',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    sponsorA: {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  };
};

const mapStateToProps = (store) => {
  const { $$organizationStore, $$railsContextStore, $$sponsorStore } = store;
  const canEditOrganization = organizationDuck.selectors.canEditOrganization(
    $$organizationStore,
    $$railsContextStore
  );
  const isPreviewingWebsite = railsContextDuck.selectors.isPreviewingWebsite(
    $$railsContextStore
  );
  const isEditingOrganization = canEditOrganization && !isPreviewingWebsite;
  return {
    sponsors: $$sponsorStore.get('$$sponsors'),
    isEditingOrganization,
  };
};

const Sponsor = ({ sponsor }) =>
  sponsor.logo_filename ? (
    <div className={css.sponsorImageContainer}>
      <Image
        // cloudName="jersey-watch"
        publicId={sponsor.logo_filename}
        height="150"
        width="150"
        crop="fit"
      />
    </div>
  ) : (
    <SponsorIcon className={css.sponsorIcon} />
  );

Sponsor.propTypes = {
  sponsor: PropTypes.object.isRequired,
};

class SponsorsTicker extends Component {
  render() {
    const { isEditingOrganization, sponsors, classes } = this.props;

    let sponsorsTitle;
    if (isEditingOrganization) {
      sponsorsTitle =
        sponsors.length === 0 ? '+ Add Sponsors' : 'Edit Sponsors';
    } else {
      sponsorsTitle = 'Sponsors';
    }

    return !isEditingOrganization && sponsors.length === 0 ? null : (
      <div style={{ backgroundColor: 'white' }}>
        <div className={css.main}>
          <Link href="/sponsors" color="inherit">
            <Typography className={classes.title} variant="h5">
              {sponsorsTitle}
            </Typography>
          </Link>
          {sponsors.length > 0 && (
            <React.Fragment>
              <div style={{ marginTop: 16 }}>
                <Slider {...settings(sponsors.length)}>
                  {sponsors.map((sponsor) =>
                    sponsor.link ? (
                      <a
                        href={sponsor.link}
                        className={classes.sponsorA}
                        key={sponsor.id}
                      >
                        <div className={css.sponsor}>
                          <Sponsor sponsor={sponsor} />
                          <Typography
                            className={classes.sponsor}
                            variant="subtitle1"
                          >
                            {sponsor.name}
                          </Typography>
                        </div>
                      </a>
                    ) : (
                      <div key={sponsor.id} className={css.sponsor}>
                        <Sponsor sponsor={sponsor} />
                        <Typography
                          className={classes.sponsor}
                          variant="subtitle1"
                        >
                          {sponsor.name}
                        </Typography>
                      </div>
                    )
                  )}
                </Slider>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

SponsorsTicker.propTypes = {
  classes: PropTypes.object.isRequired,
  isEditingOrganization: PropTypes.bool.isRequired,
  sponsors: PropTypes.array.isRequired,
};
SponsorsTicker.defaultProps = {};

export default withStyles(styles)(
  connect(mapStateToProps)(toJS(SponsorsTicker))
);
